import { forkJoin, Observable } from "rxjs";

import { ObservableSpreading } from "../../interface/type/observable-spreading.type";
import { flatMap } from "./flat-map.operator";

	/**
	 * @description
	 *  Permite construir un objeto complejo, donde cada una de sus partes se
	 *	resuelve a través de un observable de manera asincrónica. Todas las
	 *	partes de este objeto se resuelven en simultáneo, pero la siguiente
	 *	etapa del pipeline no se ejecuta hasta que el objeto completo se
	 *	conforme, lo que evita acceder a un estado inconsistente.
	 *
	 *	Como cada propiedad es un observable, es posible construir sobre cada
	 *	uno un objeto complejo de la misma forma, aplicando este mismo
	 *	operador de forma anidada.
	 *
	 * @param sources
	 *	Construye la estructura del objeto asincrónico. Recibe el resultado
	 *	del observable anterior en el pipeline, mediante el cual puede
	 *	configurar el objeto asincrónico.
	 *
	 * @returns
	 *  Un observable del objeto a construir mediante llamados asincrónicos.
	 */

export function andSpread<T, U>(sources: (value: T) => U)
	: (source: Observable<T>) => Observable<ObservableSpreading<U>> {
	return function (source: Observable<T>): Observable<ObservableSpreading<U>> {
		return source.pipe(
			flatMap(value => forkJoin(sources(value)))
		);
	};
}
